import { Instagram } from '@/components/Instagram';
import { LabradorComponent } from '@/types/component';

export const LabradorInstagram: LabradorComponent = ({ type, data, meta }) => {
  return (
    <Instagram instagramHtml={data?.instagramHtml} options={data.options} data-content-index={meta.contentIndex} />
  );
};
